export default __webpack_public_path__ + "static/media/01_DAIF_Data_01.54d5d775.mp4";